<template>
  <div class="tri-manager-tab">
    <b-field grouped>
      <base-select
        v-model="contract"
        :service="$options.contractService"
        fetch-func="all"
        :fetch-params="{
          type_tag_id: contractType.id,
          includes: 'contractor',
        }"
        label="Contract"
      >
        <template #customLabel="{ option }">
          {{ `${option.contractor.name} - ${option.name}` }}
        </template>
      </base-select>
    </b-field>

    <tri-manager-tab-table
      :fetch="tableFetch"
      :fetch-active="tableFetchActive_"
      :archive="tableArchive_"
      :restore="tableRestore_"
      :columns="tableColumns"
      ref="table"
    />
  </div>
</template>

<script>
import BaseSelect from "@/components/partials/BaseSelect";
import TriManagerTabTable from "@/components/Tri/TriManagerTabTable.vue";
import { ContractService } from "@/services/contract.service";

export default {
  contractService: ContractService,
  props: {
    contractType: {
      required: true,
    },
    tableFetch: {
      required: true,
    },
    tableFetchActive: {
      required: true,
    },
    tableArchive: {
      required: true,
    },
    tableRestore: {
      required: true,
    },
    tableColumns: {
      type: Array,
    },
  },
  components: {
    BaseSelect,
    TriManagerTabTable,
  },
  data: () => ({
    contract: "",
  }),
  computed: {
    params() {
      return {
        contract_id: this.contract || undefined,
        contract_type_tag_id: this.contract ? undefined : this.contractType.id,
      };
    },
  },
  watch: {
    contract() {
      this.$nextTick(() => {
        this.fetchTableActive();
      });
    },
  },
  methods: {
    tableFetchActive_() {
      return this.tableFetchActive
        ? this.tableFetchActive(this.params)
        : undefined;
    },
    tableArchive_(payload) {
      return this.tableArchive
        ? this.tableArchive({ ...payload, ...this.params })
        : undefined;
    },
    tableRestore_(payload) {
      return this.tableRestore
        ? this.tableRestore({ ...payload, ...this.params })
        : undefined;
    },
    async fetchTableActive() {
      try {
        this.$refs.table.$refs.baseTable.loading = true;
        await this.$refs.table.fetchActiveRows();
      } catch (err) {
        throw err;
      } finally {
        this.$refs.table.$refs.baseTable.loading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Tri/TriManagerTab.vue